import store from '@/core/store';
import refill from './store/refill';

export const connect = (opts = {}) => {
  store.registerModule('entities$refill', refill);
};
